import Head from 'next/head';
import React from 'react';
import { ZOLA_DOMAIN } from 'pages/UniversalLanding/utils';

const description =
  'Shop all wedding day paper needs! From place cards to menus and more, explore our collection of complementary paper to enhance every detail of your special day.';

const title = 'Wedding Day Paper: Programs, Place Cards, Menus, & More';

const URL = `${ZOLA_DOMAIN}/wedding-planning/day-of`;

const keywords =
  'wedding day paper, day-of paper, wedding menus, wedding place cards, wedding place cards, wedding table numbers';

export const Header: React.FC = () => (
  <Head>
    <title key="meta-title">{title}</title>
    <meta name="keywords" content={keywords} key="keywords" />
    <meta name="description" content={description} key="description" />
    <link rel="canonical" href={URL} key="canonical" />
    <meta property="og:title" content={title} key="og:title" />
    <meta property="og:description" content={description} key="og:description" />
    <meta property="og:type" content="website" key="og:type" />
    <meta property="og:url" content={URL} key="og:url" />
    <meta property="og:locale" content="en_US" key="og:locale" />
    <meta property="og:site_name" content="zola.com" key="og:site_name" />
    <meta property="og:phone_number" content="1-408-657-ZOLA" key="og:phone_number" />
    <meta property="fb:app_id" content="215495315286955" key="fb:app_id" />
    <meta name="twitter:title" content={title} key="twitter:title" />
    <meta name="twitter:description" content={description} key="twitter:description" />
    <meta name="twitter:site" content="@zola" key="twitter:site" />
    <meta name="twitter:creator" content="@zola" key="twitter:creator" />
  </Head>
);
